import { useEffect } from 'react';

import { getSimilarSoldVehicles } from 'PrivateAPI';

import { FLAG } from 'Utilities/analytics/optimizely/constants';

import { useBinaryExperiment } from '../useBinaryExperiment';

export const useSimilarVehiclesDataGathering = (dpVehicleId?: number) => {
  const isEnabled = useBinaryExperiment(FLAG.OFFER_ACCEPTANCE_SIMILAR_VEHICLES, { triggerExperiment: true });

  useEffect(() => {
    if (!isEnabled || !dpVehicleId) {
      return;
    }

    getSimilarSoldVehicles(dpVehicleId).catch(() => {});
  }, [isEnabled, dpVehicleId]);
};
